/**
 * How long the recording has been running, as the pill says it: "07:24", and
 * "1:07:24" once it is past an hour.
 *
 * Digits rather than words, because this is a clock somebody watches rather
 * than a duration they read: "7 minuten" says nothing about whether the
 * recording is still moving.
 */
export function offlineRecordingClock(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const rest = safe % 60;

  const tail = `${String(minutes).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
  return hours > 0 ? `${hours}:${tail}` : tail;
}
